import { TFunction } from 'i18next';
import { TabsItems } from 'modules/types/Tab';
import { ContractsDetailsForm } from '../contractsDetails';
import { ContractsOverviewKeys } from './helper';
import { ContractsDetailsSection } from '../contractsDetails/helper';

export const getContractsOverviewTabs = (
  t: TFunction,
  number: string,
): TabsItems[] => [
  {
    key: ContractsOverviewKeys.Details,
    component: (
      <ContractsDetailsForm
        section={ContractsDetailsSection.DETAILS}
        number={number}
      />
    ),
  },
  // FRON-514 commented for release day
  // {
  //   key: ContractsOverviewKeys.RepaymentPlan,
  //   component: (
  //     <ContractsDetailsForm section={ContractsDetailsSection.REPAYMENT_PLAN} />
  //   ),
  // },
  {
    key: ContractsOverviewKeys.FacilityInformation,
    component: (
      <ContractsDetailsForm
        section={ContractsDetailsSection.FACILITY_INFORMATION}
        number={number}
      />
    ),
  },
];
